module.exports = __webpack_public_path__ + "static/media/S2N12-2.550dd15e.svg";